(function () {
  "use strict";

  // Chooses between the React job-detail page and the legacy Angular controller
  // for a given job, gated per-tenant by the `react-job-detail` feature flag.
  // A missing flag evaluates to control (off), so tenants stay on Angular until
  // the flag is created and ramped.
  angular.module("app").component("jobDetailDispatch", {
    bindings: {
      jobId: "<",
      legacyTemplate: "@"
    },
    controller: JobDetailDispatchController,
    template:
      '<div ng-if="$ctrl.resolved">' +
      '  <job-detail-page ng-if="$ctrl.reactEnabled" job-id="$ctrl.jobId"></job-detail-page>' +
      '  <div ng-if="!$ctrl.reactEnabled" ng-include="$ctrl.legacyTemplateUrl"></div>' +
      '</div>'
  });

  JobDetailDispatchController.$inject = ["featureFlagService", "version"];

  function JobDetailDispatchController(featureFlagService, version) {
    var vm = this;

    vm.$onInit = function () {
      vm.legacyTemplateUrl = "/views/ProjectsTickets/" + vm.legacyTemplate + ".html?v=" + version;
      featureFlagService.reactJobDetail().then(function (enabled) {
        vm.reactEnabled = enabled;
        vm.resolved = true;
      });
    };
  }
})();
